import React from 'react';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { JiraIcon } from '@atlaskit/logo';
import { FormattedMessage } from '@atlassian/jira-intl';
import Button from '@atlassian/jira-portfolio-3-common/src/button/index.tsx';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda/index.tsx';
import {
	type ConfluenceMacroType,
	DEPENDENCY_REPORT_SHARE_TYPE,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant.tsx';
import {
	PLAN_PAGES,
	openInNewTab,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/window/index.tsx';
import messages from './messages.tsx';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types.tsx';

const getPlanUrl = (confluenceMacroType: ConfluenceMacroType) => {
	switch (confluenceMacroType) {
		case DEPENDENCY_REPORT_SHARE_TYPE:
			return PLAN_PAGES.DEPENDENCIES_REPORT;
		default:
			return PLAN_PAGES.ROADMAP;
	}
};

export const Footer = ({ plan, confluenceMacroType }: Props) => {
	const { id = 0, currentScenarioId = 0 } = plan;
	const url = `/jira/plans/${id}/scenarios/${currentScenarioId}/${getPlanUrl(confluenceMacroType)}`;

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<div className={styles.footer}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.bottomBar}>
				<Button
					appearance="link"
					onClick={() => {
						// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
						openInNewTab(window.location.href);
					}}
					iconBefore={<ShortcutIcon label="" size="small" />}
				>
					<FormattedMessage {...messages.openInNewTab} />
				</Button>
				{isDefined(plan.currentScenarioId) && isDefined(plan.id) && (
					<Button
						appearance="link"
						onClick={() => {
							openInNewTab(url);
						}}
						iconBefore={<JiraIcon size="small" />}
					>
						<FormattedMessage {...messages.viewInJira} />
					</Button>
				)}
			</div>
		</div>
	);
};
